import type { StrongPasswordOptions } from "validator";

/** Compatible with validator.isStrongPassword (excludes returnScore to match boolean overload). */
export const PASS_VALIDATORS: Omit<StrongPasswordOptions, "returnScore"> = {
  minLength: 4,
  minUppercase: 1,
  minSymbols: 0,
  minNumbers: 1,
};

/** @deprecated Prefer intl.formatMessage({ id: 'validators.passwordRequirements' }) */
export const PASS_ERROR_TEXT = `Le mot de passe doit contenir au moins ${PASS_VALIDATORS.minLength} caractères, au moins une lettre majuscule et un chiffre.`;

/** @deprecated Prefer intl.formatMessage({ id: 'validators.passwordMismatch' }) */
export const PASSWORD_MISMATCH = "Les deux mots de passe doivent être identiques";

/** @deprecated Prefer intl.formatMessage({ id: 'validators.required' }) */
export const getRequiredError = (name: string, lastWithE?: boolean) =>
  `${name} est requis${lastWithE ? "e" : ""}`;

export const hasValue = (value?: string | number) => !!(value && value.toString().length > 0);
